module.exports = __webpack_public_path__ + "static/media/shader.fe6860be.frag";


//////////////////
// WEBPACK FOOTER
// ./src/lib/vendor/postprocessing/materials/glsl/adaptive-luminosity/shader.frag
// module id = 262
// module chunks = 0